import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import LanguageToggle from "@/components/LanguageToggle";
import LandingPage from "@/pages/LandingPage";
import CampRegistration from "@/pages/CampRegistration";
import TShirtPreorder from "@/pages/TShirtPreorder";
import AdminDashboard from "@/pages/AdminDashboard";
import CampCalendar from "@/pages/CampCalendar";
import PlayerProgress from "@/pages/PlayerProgress";
import SubmitTestimonial from "@/pages/SubmitTestimonial";
import ParentLogin from "@/pages/ParentLogin";
import ParentForgotPassword from "@/pages/ParentForgotPassword";
import ParentResetPassword from "@/pages/ParentResetPassword";
import ParentDashboard from "@/pages/ParentDashboard";

function App() {
  return (
    <LanguageProvider>
      <div className="App noise-bg">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/register" element={<CampRegistration />} />
            <Route path="/tshirt" element={<TShirtPreorder />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/calendar" element={<CampCalendar />} />
            <Route path="/progress" element={<PlayerProgress />} />
            <Route path="/submit-testimonial" element={<SubmitTestimonial />} />
            <Route path="/parent/login" element={<ParentLogin />} />
            <Route path="/parent/forgot-password" element={<ParentForgotPassword />} />
            <Route path="/parent/reset-password" element={<ParentResetPassword />} />
            <Route path="/parent/dashboard" element={<ParentDashboard />} />
          </Routes>
        </BrowserRouter>
        <LanguageToggle variant="floating" />
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
